/* eslint-disable jsx-a11y/anchor-is-valid */
import classNames from "classnames";
import { emailRegex } from "components/InputsMex/validaciones";
import ProgressSpinner from "components/PogressSpinners/ProgressSpinner";
import useCustomToasts from "hooks/useCustomToasts";
import React, { memo, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Collapse } from "reactstrap";
import { onEnviarCorreo } from "../hogar.actions";

const OpcionesPago = memo(function OpcionesPago({
  loading,
  datosTarifacion,
  idCotizacion,
  correo,
  disablebtn,
  userIsLoggedIn = false,
}) {
  const { addSuccessToast, addWarningToast } = useCustomToasts();
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  useEffect(() => {
    setIsOpen(false);
  }, [datosTarifacion]);

  const [loadc, setloadc] = useState(false);

  const { register, errors, handleSubmit, reset } = useForm({
    mode: "onChange",
    defaultValues: { correo },
  });

  const enviarCorreo = async ({ correo }) => {
    try {
      setloadc(true);
      let res = await onEnviarCorreo({ correo, idCotizacion });
      if (res.transaccion) {
        addSuccessToast(`Hemos enviado tu cotización al correo ${correo}`);
      } else {
        addWarningToast("Ha ocurrido un problema al enviar el correo");
        reset({ correo });
      }
    } catch (error) { }
    setloadc(false);
  };

  return (
    <React.Fragment>
      {loading && <ProgressSpinner label="Recalculando..." />}

      <div className={classNames("w-100", { "d-none": loading })}>
        <h2 className="font-mex mt-4 mb-3 text-mex font-26px">
          Descripción de pago
        </h2>
        <div className="d-flex gridtitulovalor">
          <h5 className="font-source-sans-regular font-20px">Prima neta anual</h5>
          <h5 className="font-20px">${datosTarifacion?.primaNeta} {(userIsLoggedIn) ? datosTarifacion?.monedaSimbolo : 'mxn'}</h5>
        </div>
        <div className="d-flex flex-row justify-content-between my-2">
          <h3 className="text-primary font-26px">Cargos extras</h3>

          <h6 className="prima-valores font-weight-bold font-20px align-self-center">
            ${datosTarifacion?.impuestosTotal} {(userIsLoggedIn) ? datosTarifacion?.monedaSimbolo : 'mxn'}
          </h6>
        </div>

        {datosTarifacion?.impuestosGenerados?.map((item, i) => (
          <div
            key={`opcionpago-${i}`}
            className="d-flex flex-row justify-content-between"
          >
            <p className="font-source-sans-regular ml-4 font-20px">
              {item?.impCodigo === "derecho" && "Derechos de póliza"}
              {item?.impCodigo !== "derecho" && item?.impuestoNom}
            </p>
            <p className="font-source-sans-regular font-20px">
              ${item?.impuestoValor} {(userIsLoggedIn) ? datosTarifacion?.monedaSimbolo : 'mxn'}
            </p>
          </div>
        ))}

        <div className="d-flex gridtitulovalor">
          <h3 className="text-primary font-26px">Total a pagar</h3>

          <h3 className="prima-valores font-weight-bold font-19px align-self-center">
            ${datosTarifacion?.primaTotal} {(userIsLoggedIn) ? datosTarifacion?.monedaSimbolo : 'mxn'}
          </h3>
        </div>

        {datosTarifacion?.planPagos?.length > 0 && (
          <div className="row justify-content-center mt-2">
            <div className="col-12">
              <h4 className="cpointer" onClick={toggle}>
                Detalle de pagos <i className="pi pi-chevron-down" />
              </h4>
              <Collapse isOpen={isOpen}>
                {datosTarifacion?.planPagos?.map((e, index) => (
                  <div className="w-100" key={index * 123}>
                    <p className="d-inline ml-2 font-20px">{e.labelPago}</p>
                    <p className="float-right font-20px">${e.primaTotal} {(userIsLoggedIn) ? datosTarifacion?.monedaSimbolo : 'mxn'}</p>
                  </div>
                ))}
              </Collapse>
            </div>
          </div>
        )}
      </div>

      <div className="d-flex justify-content-end my-4 ">
        <a
          href={datosTarifacion?.urlPdfCotizacion}
          target="_blank"
          rel="noopener noreferrer"
          aria-disabled={loading}
          download="proposed_file_name"
        >
          <button
            className="btn btn-primary"
            type="button"
            disabled={loading || disablebtn}
          >
            DESCARGAR COTIZACIÓN
          </button>
        </a>
      </div>

      <div
        className={classNames("my-4", {
          "d-none": loadc,
        })}
      >
        <label className="lbl-env-correo font-20px" htmlFor="env-correo-api">
          Confirma tu correo para recibir tu cotización ahora
        </label>
        <div className="input-group input-group-lg">
          <input
            type="text"
            className="form-control enviar-cot"
            aria-label="Sizing example input"
            aria-describedby="inputGroup-sizing-lg"
            placeholder="Ingresa tu correo "
            id="env-correo-api"
            name="correo"
            ref={register({
              required: "Este campo es obligatorio",
              pattern: {
                value: emailRegex,
                message: "Ingrese un correo válido",
              },
            })}
          />

          <div className="input-group-prepend">
            <button
              className="btn btn-primary rounded-right text-uppercase"
              onClick={handleSubmit(enviarCorreo)}
              disabled={loading || loadc || disablebtn}
            >
              Enviar cotización
            </button>
          </div>
        </div>
        <strong className="error-msg-input">{errors?.correo?.message}</strong>
      </div>

      {loadc && <h3 className="font-mex">Enviando correo...</h3>}
    </React.Fragment>
  );
});

OpcionesPago.propTypes = {};

export default OpcionesPago;
